import { defineComponent as v, ref as d, computed as t } from "vue";
import { addCdnHost as s } from "./td-longtail-vue-components251.js";
import B from "./td-longtail-vue-components14.js";
import { useReducedMotion as P } from "./td-longtail-vue-components90.js";
const g = /* @__PURE__ */ v({
  __name: "video-player",
  props: {
    controls: { type: Boolean, default: !1 },
    src: { default: "" },
    poster: { default: void 0 },
    loop: { type: Boolean, default: !1 },
    autoplay: { type: Boolean, default: !1 },
    muted: { type: Boolean, default: !1 },
    videoType: { default: void 0 },
    playsinline: { type: Boolean, default: !0 },
    preload: { default: "auto" },
    playButtonCentered: { type: Boolean, default: !0 },
    hidePlayButton: { type: Boolean, default: !1 },
    videoAriaLabel: { default: "Werbevideo" },
    playButtonAriaLabel: { default: "Video abspielen" },
    pauseButtonAriaLabel: { default: "Video pausieren" }
  },
  setup(r, { expose: p }) {
    const e = r, i = P(), a = d(!1), l = d(null), n = t(() => s(e.src)), f = t(() => e.poster ? s(e.poster) : void 0), y = t(() => !a.value && !e.hidePlayButton), c = t(() => e.videoType ? e.videoType : n.value.replace(/.*\.(\w+)$/i, (o, m) => m.toLowerCase())), u = () => {
      const o = l.value;
      o && (o.paused ? o.play() : o.pause());
    };
    return p({ togglePlay: u }), { __sfc: !0, isReducedMotion: i, props: e, isPlaying: a, videoElement: l, videoSrc: n, posterSrc: f, doShowPlayButton: y, type: c, togglePlay: u, PlayPauseButton: B };
  }
});
export {
  g as default
};
